module.exports = __webpack_public_path__ + "img/ico_question_blue.b9975c31.svg";